import React from 'react';
import PropTypes from 'prop-types';
import { buildAvailablePrograms } from 'utils/component.utils';
import SelectAttribute from 'components/SelectAttribute';
import InputContainer from '../../InputContainer';

const FieldEditorDegreeOffering = (props) => {
  const {
    availablePrograms,
    fieldValidityChanged,
    keyPath,
    onFieldValueChange,
    onFieldUIStateChange,
    values,
    uiState,
  } = props;

  const validateAndChangeDegreeOffering = (kp, programId) => {
    const { degreeOffering } = availablePrograms.find((program) => program.programId === +programId) || {};
    onFieldValueChange([...keyPath, 'degreeOfferingConfig'], { programId, degreeOffering });

    if (programId) {
      fieldValidityChanged(kp, true);
    }
  };

  return (
    <div className="col mt-2">
      <div className="row mb-4">
        <div className="col-sm-6">
          <InputContainer
            label="Degree Offering Value"
            keyPath={[...keyPath, 'degreeOfferingConfig', 'programId']}
            uiState={uiState.editors.degreeOfferingConfig.programId}
          >
            <SelectAttribute
              keyPath={[...keyPath, 'degreeOfferingConfig', 'programId']}
              onFieldValueChange={validateAndChangeDegreeOffering}
              onFieldUIStateChange={onFieldUIStateChange}
              options={buildAvailablePrograms(availablePrograms)}
              value={values.editors.degreeOfferingConfig.programId}
              disableNullOption
            />
          </InputContainer>
        </div>
      </div>
    </div>
  );
};

FieldEditorDegreeOffering.propTypes = {
  availablePrograms: PropTypes.array.isRequired,
  fieldValidityChanged: PropTypes.func.isRequired,
  keyPath: PropTypes.array.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  uiState: PropTypes.object.isRequired,
  values: PropTypes.shape({
    flags: PropTypes.array.isRequired,
    hidden: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    uiOrder: PropTypes.number,
    editors: PropTypes.shape({
      degreeOfferingConfig: PropTypes.shape({
        degreeOffering: PropTypes.string.isRequired,
        programId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    __typename: PropTypes.string,
  }).isRequired,
};

export default function FieldDegreeOfferingConfigure(props) {
  return <FieldEditorDegreeOffering {...props} />;
}
